function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFvicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 35.5,
    r: 3,
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36.5 43.5 38.5 46.5 21.5 46.5 23.5 43.5 36.5 43.5",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 35.5,
    r: 3,
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5,21.59V18.24a3.73428,3.73428,0,0,1,3.74-3.74H35.76a3.73428,3.73428,0,0,1,3.74,3.74v3.35a3.90927,3.90927,0,0,1-3.91,3.91H23.41A3.90927,3.90927,0,0,1,19.5,21.59Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5.5a29,29,0,1,0,29,29A28.99518,28.99518,0,0,0,30.5.5Zm10.62344,50-1.42372-2H20.13945l-1.36056,2H14.5l6.76-8.7a8.03977,8.03977,0,0,1-4.76-7.33V13.44A4.9378,4.9378,0,0,1,21.44,8.5H37.56a4.9378,4.9378,0,0,1,4.94,4.94V34.47a8.029,8.029,0,0,1-4.19,7.05L45.5,50.5Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    style: {
      fill: "none"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFvicon);
export default __webpack_public_path__ + "static/media/fvicon.7718dc575848afed9f1cf1d24e2aa775.svg";
export { ForwardRef as ReactComponent };